import { useCallback, useEffect, useMemo, useState } from "react"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import EmptyComponent from "../../../../../Components/Empty"
import Filters from "../../../../../Components/Filters"
import Table from "../../../../../Components/Table"
import { RoutesPaths } from "../../../../../constants/user-routes"
import { serializeData } from "../../../../../Utils/utils"
import Creators from "../../reducer"
import { defaultColumns, getColumns, getDefaultColumn } from "./columns"

import "../webhooks.less"

const allFilters = [
  { field_id: "event_name", label: "Event name", active: true },
  { field_id: "source_id", label: "Source ID", active: true },
  { field_id: "created", label: "Date", active: true }
]

const EventsTable = ({ eventTypeOptions = [] }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { webhooksFetching, events, filtersEvents } = useSelector((state) => state.publicApi)
  const { theme } = useSelector((state) => state.nav)
  const eventTypeFilterOptions = eventTypeOptions.map((item) => ({
    id: item.value,
    name: item.label || item.value
  }))
  const safeFiltersEvents = filtersEvents || { exclude_fields: [] }
  const results = events?.results || []
  const count = events?.count || results.length
  const pageSize = 10
  const [pageNumber, setPageNumber] = useState(1)
  const [ordering, setOrdering] = useState(null)

  const myColumns = defaultColumns

  const tableSettings = useMemo(
    () => ({
      scroll: {
        x: "auto"
        // y: 'calc(100vh - 72px - 24px - 32px - 24px - 43px - (16px + 32px + 16px))',
        // scrollToFirstRowOnChange: true,
      },
      pagination: {
        total: count,
        current: pageNumber,
        pageSize: pageSize
      },
      locale: {
        emptyText: (
          <div className="webhooks-events-empty-wrapper">
            <EmptyComponent type="no_data_available_webhooks_events" />
          </div>
        )
      }
    }),
    [count, pageNumber]
  )

  // function handleSelectRow(data, type) {
  //   if (type === 'add_event') {
  //     setModalType({type, data})
  //   }
  // }

  const handleChangeTable = useCallback((pagination, filters, sorter) => {
    let ordering = null
    if (sorter) {
      if (Array.isArray(sorter)) {
        ordering = sorter
          ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
          .join(",")
      } else {
        if (sorter.order) {
          ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
        }
      }
    }
    setPageNumber(pagination.current)
    setOrdering(ordering)
  }, [])

  const getTableColumns = useMemo(
    (type) => {
      let allColumns = getColumns({ theme })

      // const actionColumn = getActionColumn({
      //   onSelectRow: handleSelectRow
      // });

      return [
        ...myColumns
          .filter(({ active }) => active)
          .map((data) => allColumns?.[data.field_id] || getDefaultColumn({ ...data }))
        // ...(actionColumn ? [actionColumn] : [])
      ]
    },
    [theme]
  )

  const updateData = () => {
    const serializeFilters = serializeData(safeFiltersEvents)
    const createdTimestamp = serializeFilters?.created_timestamp
    const [dateFrom, dateTo] = createdTimestamp ? createdTimestamp.split(",") : []

    const data = {
      page: pageNumber,
      page_size: pageSize,
      ordering,
      ...serializeFilters,
      event_type: serializeFilters?.event_name,
      date_from: dateFrom,
      date_to: dateTo
    }

    delete data.event_name
    delete data.created_timestamp

    // console.log('updateData', data)
    dispatch(Creators.getEventsRequest({ ...data }))
  }

  const openEventDetails = (eventData) => {
    if (eventData?.id) {
      navigate(`${RoutesPaths.settings.developers_webhooks}/events/${eventData?.id}`)
    }
  }

  const handleChangeFilter = useCallback((newData) => {
    console.log("handleChangeFilter", newData)
    dispatch(Creators.publicApiSetProp("filtersEvents", newData))
    setPageNumber(1)
  }, [])

  useEffect(() => {
    updateData()
  }, [ordering, pageNumber, safeFiltersEvents])

  return (
    <div style={{ marginTop: 16 }}>
      <Filters
        visibleFilters={{ event_name: true, source_id: true, created_timestamp: true }}
        filterOptions={{ event_name: eventTypeFilterOptions }}
        allFilters={allFilters}
        filters={safeFiltersEvents}
        onChangeFilter={handleChangeFilter}
        withoutAdd={true}
        filtersType={"events_table"}
      />
      <div style={{ marginTop: 16 }}>
        <Table
          columns={getTableColumns}
          loading={webhooksFetching}
          dataSource={results}
          scroll={tableSettings.scroll}
          onChange={handleChangeTable}
          pagination={tableSettings.pagination}
          showSizeChanger={false}
          //withOutPagination={true}
          locale={tableSettings.locale}
          rowHoverable={true}
          onRow={(record) => ({
            onClick: (event) => {
              openEventDetails(record)
            }
          })}
        />
      </div>
    </div>
  )
}

export default EventsTable
